import {BaseResponse} from "../../types/baseEntities";
import {HttpAxiosRequest} from "../httpAxiosBase";
import {Activity, ActivityOnboardingComplete, ActivityStatusStory} from "../../types/activity/activityData";
import {ActivityFile} from "../../types/activity/activityFile";
import {FileBase, FileBaseFields} from "../../types/solicitation/solicitationFile";

export const HttpOnboardingActivity = {
    getEndpoint: (url: string): string => `onboarding-actividad${url}`,

    complete : (activityId: number, data: ActivityOnboardingComplete) : Promise<BaseResponse> => {
        return HttpAxiosRequest.post(
            HttpOnboardingActivity.getEndpoint(`/${activityId}/completar`),
            data
        )
    }
}


export const HttpActivity = {
    getEndpoint: (url: string) : string => `actividad${url}`,
    
    getById: (intIdActivity: number): Promise<Activity> => {
        return HttpAxiosRequest.get(
            HttpActivity.getEndpoint(`/${intIdActivity}`)
        );
    },
}

export const HttpActivityStatusStory = {
    getEndpoint: (url: string): string => `actividad-estado-historia${url}`,

    getByIdActivity: (intIdActivity: number) : Promise<ActivityStatusStory[]> => {
        return HttpAxiosRequest.get(
            HttpActivityStatusStory.getEndpoint(`/${intIdActivity}`)
        );
    },

}


export const HttpActivityFile = {
    getEndpoint: (intIdActivity: number, url: string): string => `actividad/${intIdActivity}/archivo${url}`,
    
    getList: (intIdActivity: number): Promise<ActivityFile[]> => {
        return HttpAxiosRequest.get(
            HttpActivityFile.getEndpoint(intIdActivity, '')
        )
    },
    
    insertFile: (intIdActivity: number, fileActivity?: FileBase, file?: File, fileId?: number) : Promise<number> => {
        const formData : FormData = new FormData();

        if (fileActivity && file) {
            formData.append("codArchivoTipo", fileActivity.codArchivoTipo.toString());
            formData.append("tieneArchivoFisico", 'false');
            formData.append("descArchivo", fileActivity.descArchivo);
            formData.append("observacion", fileActivity[FileBaseFields.Observation])
            formData.append("file", file, fileActivity.descArchivo);
        }else if (fileId) {
            formData.append("idArchivo", fileId.toString());
        }
        
        return HttpAxiosRequest.post(
            HttpActivityFile.getEndpoint(intIdActivity,''),
            formData
        )
    }
}